import { textItems } from './shared';

export const h5 = {
  title: 'H5',
  ...textItems,
  styles: {
    ...textItems.styles,
    fontSize: '16px',
  },
};
